/*============================================================
   REACT DEPENDENCIES
============================================================*/
import { useEffect, useState } from "react";

/*============================================================
   REDUX DEPENDENCIES
============================================================*/
import { useSelector, useDispatch } from "react-redux";

import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";

import GridSectionHeader from "../../../widgets/GridSectionHeader";

import { removeCommaFromCurrency, convertLocaleString } from "../../../../utils/fieldValidator.js";

//DATA SLICE - REDUCER
import { updateSummary } from "../../../../states/slcAssetLiability.js";

export default function Summary() {
  const summary = useSelector((state) => state.assetliability);

  //LOAD DATA FROM GLOBAL DATA MANAGER
  const totalCashAsset = summary.totalCashAsset;
  const totalPersonalUseAsset = summary.totalPersonalUseAsset;
  const totalInvestmentAsset = summary.totalInvestmentAsset;
  const totalShortTermLiability = summary.totalShortTermLiability;
  const totalLongTermLiability = summary.totalLongTermLiability;

  const [totalAssets, setTotalAssets] = useState(summary.totalassets);
  const [totalLiabilities, setTotalLiabilities] = useState(summary.totalliabilities);
  const [totalNetworth, setTotalNetworth] = useState(summary.totalnetworth);

  const dispatch = useDispatch();

  /**==============================
  * EFFECTS
  ==============================*/
  useEffect(() => {
    var totalAssets =
      Number(removeCommaFromCurrency(totalCashAsset)) +
      Number(removeCommaFromCurrency(totalPersonalUseAsset)) +
      Number(removeCommaFromCurrency(totalInvestmentAsset));

    var totalLiability =
      Number(removeCommaFromCurrency(totalShortTermLiability)) +
      Number(removeCommaFromCurrency(totalLongTermLiability));
    var networth = totalAssets - totalLiability;

    totalAssets = convertLocaleString(totalAssets, "en-US", 2);
    totalLiability = convertLocaleString(totalLiability, "en-US", 2);
    networth = convertLocaleString(networth, "en-US", 2);

    setTotalAssets(totalAssets);
    setTotalLiabilities(totalLiability);
    setTotalNetworth(networth);

    updateRedux("totalassets", totalAssets, updateSummary);
    updateRedux("totalliabilities", totalLiability, updateSummary);
    updateRedux("totalnetworth", networth, updateSummary);
  }, [totalCashAsset, totalPersonalUseAsset, totalInvestmentAsset, totalShortTermLiability, totalLongTermLiability]);

  function updateRedux(fieldName, fieldValue, reducer) {
    const action = {
      type: fieldName,
      payload: fieldValue,
    };
    dispatch(reducer(action));
  }

  return (
    <>
      <Grid container spacing={2}>
        <GridSectionHeader
          sectionName="Summary"
          sx={{
            p: 1,
            pl: 1.8,
            mt: 0,
            mb: 1,
            fontSize: 18,
            fontWeight: "bold",
            color: "#FFFFFF", //WHITE
            // color: "#000000", //BLACK
            // backgroundColor: "#d9d9d9",
            backgroundColor: "#10B981",
          }}
        />

        <Grid size={10}>
          <Typography variant="h6" gutterBottom sx={{ backgroundColor: "white" }}>
            Total Assets
          </Typography>
        </Grid>

        <Grid size={2}>
          <Typography variant="h6" gutterBottom sx={{ backgroundColor: "white" }}>
            ${totalAssets}
          </Typography>
        </Grid>

        <Grid size={10}>
          <Typography variant="h6" gutterBottom sx={{ backgroundColor: "white" }}>
            Total Liabilities
          </Typography>
        </Grid>

        <Grid size={2}>
          <Typography variant="h6" gutterBottom sx={{ backgroundColor: "white" }}>
            ${totalLiabilities}
          </Typography>
        </Grid>

        <Grid size={10}>
          <Typography variant="h6" gutterBottom sx={{ backgroundColor: "white" }}>
            Networth
          </Typography>
        </Grid>

        <Grid size={2}>
          <Typography variant="h6" gutterBottom sx={{ backgroundColor: "white" }}>
            ${totalNetworth}
          </Typography>
        </Grid>
      </Grid>
    </>
  );
}
